import type { FunctionalComponent } from 'preact';

/** 시안 .loading-spinner. hidden 클래스로 표시를 토글한다. */
export const LoadingSpinner: FunctionalComponent<{ show?: boolean }> = ({ show }) => (
  <div class={show ? 'loading-spinner' : 'loading-spinner hidden'}>
    <div class="spinner" />
  </div>
);
